import random from 'toxilibs/random.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'functions_as_params2',
    dependencies: [
        'levels/functions_as_params'
    ]
})



level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 3)
        let b = random.intBetween(0, 3)
        if (b === a) {
            b += 2
        }
        let name = random.fairChoice(['hi', 'hello'], {name: 'methodName2'})
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha, a, b) {'
            + '\n\treturn hahaha(a, b)'
            + '\n}'

            + '\n\nbonjour(' + name + ', ' + a + ', ' + b + ')'
        )
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 3)
        let b = random.intBetween(0, 3)
        if (b === a) {
            b += 2
        }
        let name = random.fairChoice(['hi', 'hello'], {name: 'methodName3'})
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha, a, b) {'
            + '\n\treturn hahaha(a, b) + 1'
            + '\n}'

            + '\n\nbonjour(' + name + ', ' + a + ', ' + b + ')'
        )
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 3)
        let b = random.intBetween(0, 3)
        if (b === a) {
            b += 2
        }
        let name = random.fairChoice(['hi', 'hello'], {name: 'methodName4'})
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha, a, b) {'
            + '\n\treturn hahaha(a + 1, b + 1)'
            + '\n}'

            + '\n\nbonjour(' + name + ', ' + a + ', ' + b + ')'
        )
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 3)
        let b = random.intBetween(0, 3)
        if (b === a) {
            b += 2
        }
        let name = random.fairChoice(['hi', 'hello'], {name: 'methodName5'})
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha, a, b) {'
            + '\n\treturn hahaha(a, b) + hahaha(1, a)'
            + '\n}'

            + '\n\nbonjour(' + name + ', ' + a + ', ' + b + ')'
        )
    }
})


level.addQuestion({
    generator: function (q) {
        let a = random.intBetween(0, 3)
        let b = random.intBetween(0, 3)
        if (b === a) {
            b += 2
        }
        let nameA = random.pick('hi', 'hello')
        let nameB = random.pick('hi', 'hello')
        q.addJSCode(
            'function hi (a, b) {'
            + '\n\treturn a + b'
            + '\n}'

            + '\n\nfunction hello (a, b) {'
            + '\n\treturn a * b'
            + '\n}'

            + '\n\nfunction bonjour (hahaha, hihihi, a, b) {'
            + '\n\treturn hahaha(a, b) + hihihi(1, a)'
            + '\n}'

            + '\n\nbonjour(' + nameA + ', ' + nameB + ', ' + a + ', ' + b + ')'
        )
    },
    times: 2
})


export default level

